module.exports = __webpack_public_path__ + "img/puzzle_1.8002f314.png";